:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._addSectionButton_xqbd9_7 {
  background-color: var(--bg-color) !important;
  color: var(--text-color) !important; }
  ._addSectionButton_xqbd9_7.btn-md {
    padding: 3px 18px 3px 12px; }
  ._addSectionButton_xqbd9_7._sharpBorderTop_xqbd9_12 {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }
  ._addSectionButton_xqbd9_7 ._icon_xqbd9_15 * {
    fill: var(--icon-color); }

._legacy_xqbd9_18 {
  --bg-color: #6f56f9;
  --text-color: #fff;
  --icon-color: #ffffff; }
  ._legacy_xqbd9_18:hover {
    --bg-color: #4429da; }
